<template >
  <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center" v-if="enabled==false">
      <div class="col-xl-10 col-lg-12 col-md-12">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row justify-content-center">
              <div class="col-lg-10 col-md-10 col-sm-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">Хувийн мэдээлэл оруулах</h1>
                    <p
                      class="text-danger"
                    >Системд бүртгэлтэй мэдээллийг оруулж баталгаажуулснаар системийг ашиглаx боломжтой болно.</p>
                  </div>

                  <div v-if="isTeacher==true">
                    <h3>Багш</h3>
                    <form class="user">
                      <div>
                        <div class="form-group">
                          <label for="exampleInputEmail1">Бүртгэлтэй имэйл хаягаа оруулна уу</label>
                          <input
                            v-model.trim="teacherForm.email"
                            type="text"
                            class="form-control"
                            id="exampleInputEmail"
                            aria-describedby="emailHelp"
                            placeholder="Та имэйл хаягаа оруулна уу"
                          />
                        </div>
                        <div class="form-group" >
                          <label for="exampleInputEmail1">Багшийн кодоо оруулна уу</label>
                          <input
                            v-model.trim="teacherForm.code"
                            type="text"
                            class="form-control"
                            id="exampleInputPassword"
                            placeholder="Та кодоо оруулна уу"
                          />
                        </div>
                      </div>

                      <div @click="saveTeacher" class="btn btn-primary btn-block">
                        <span>Хадгалах</span>
                      </div>
                      <hr />
                    </form>
                  </div>


                  <div v-if="isTeacher==false">
                    <h3>Оюутан</h3>
                    <form class="user">
                      <div>
                        <div class="form-group">
                          <label for="exampleInputEmail1">Регистрийн дугаараа оруулна уу</label>
                          <input
                            v-model.trim="loginForm.register"
                            type="text"
                            class="form-control"
                            id="exampleInputEmail"
                            aria-describedby="emailHelp"
                            placeholder="Та регистрийн дугаараа оруулна уу"
                          />
                        </div>
                        <div class="form-group" >
                          <label for="exampleInputEmail1">Оюутаны кодоо оруулна уу</label>
                          <input
                            v-model.trim="loginForm.code"
                            type="text"
                            class="form-control"
                            id="exampleInputPassword"
                            placeholder="Та оюутны кодоо оруулна уу"
                          />
                        </div>
                      </div>

                      <div @click="saveStudent" class="btn btn-primary btn-block">
                        <span>Хадгалах</span>
                      </div>
                      <hr />
                    </form>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../../firebaseConfig.js");

export default {
  name: "AddInfo",
  data() {
    return {
      loginForm: {
        register: "",
        code: ""
      },
      teacherForm:{
        code:null,
        email:null
      },
      isTeacher: false,
      provider: null
    };
  },
  computed: {
    ...mapState(["currentUser", "enabled"])
  },
  created() {
    var _this = this;
    if (this.currentUser != null) {
      fb.usersCollection
        .doc(this.currentUser.uid)
        .get()
        .then(userData => {
          if (userData != null && userData.exists) {
            this.provider = userData.data().provider;
            if (
              userData.data().verified == true
            ) {
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            } 
            else {
                if (userData.data().role == "teacher") {
                  this.isTeacher = true;
                } 
                else {
                  this.isTeacher = false;
                }
            }
          }
        });
    }
  },
  methods: {
    async saveTeacher(){
      if(this.teacherForm!=null && this.teacherForm.code!=null && this.teacherForm.code!='' 
      && this.teacherForm.email!=null && this.teacherForm.email!=''){
        var datas = await fb.db
            .collection("teachers")
            .where("code", "==", this.teacherForm.code.toLowerCase()).where("email", "==", this.teacherForm.email)
            .limit(1)
            .get();
          if (!datas.empty) {
            var userObj=datas.docs[0];
            if(userObj && userObj.exists && userObj.data() && userObj.data().googleUser){
              alert(userObj.data().email+ " имэйл хаягтай багш аль хэдийн өөр account - р нэвтэрсэн байна.");
              return;
            }
            else{
              var userRef=fb.usersCollection.doc(this.currentUser.uid);
              userRef.update({"verified": true, "customer": userObj.ref, "role":"teacher", "verifiedAt":new Date(), "code": this.teacherForm.code.toLowerCase(), "email": this.teacherForm.email});
              userObj.ref.update({'googleUser':userRef});
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            }
          } 
          else {
            alert(
              "Таны оруулсан мэдээлэл системд бүртгэлгүй байна . Та сургалтын албандаа хандана уу."
            );
            return;
          }
      }
      else{
        alert("Та мэдээллээ бүрэн оруулна уу");
      }
    },
    async saveStudent(){
      if(this.loginForm!=null && this.loginForm.code!=null && this.loginForm.code!='' 
      && this.loginForm.register!=null && this.loginForm.register!=''){
        var datas = await fb.db
            .collection("students")
            .where("code", "==", this.loginForm.code.toLowerCase()).where("register", "==", this.loginForm.register.toLowerCase())
            .limit(1)
            .get();
          if (!datas.empty) {
            var userObj=datas.docs[0];
            var userRef=fb.usersCollection.doc(this.currentUser.uid);
            if(userObj.data().user!=null){
              alert("Өөр account р нэвтэрсэн байна.");
              return ;
            }
            else{
              userRef.update({"verified": true, "customer": userObj.ref, "role":"student", "verifiedAt":new Date(), "code": this.loginForm.code.toLowerCase(), "register": this.loginForm.register.toLowerCase()});
              if(this.provider!=null && this.provider!=''){
                var propName=this.provider+'User';
                var obj={};
                obj[propName]=userRef;
                userObj.ref.update(obj);
              }
              else
                userObj.ref.update({'user':userRef});
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            }
          } 
          else {
            alert(
              "Таны оруулсан мэдээлэл системд бүртгэлгүй байна . Та сургалтын албандаа хандана уу."
            );
          }
      }
      else{
        alert("Та мэдээллээ бүрэн оруулна уу");
      }
    },

    async login() {
      this.performingRequest = true;
      if (this.showUserName == true) {
        if (
          this.loginForm != null &&
          this.loginForm.register != null &&
          this.loginForm.register != ""
        ) {
          var datas = await fb.db
            .collection("teachers")
            .where("register", "==", this.loginForm.register)
            .limit(1)
            .get();
          if (!datas.empty) {
            this.isTeacher = true;
            this.showUserName = false;
            this.showCode = true;
          } 
          else {
            var stsdata = await fb.db
              .collection("students")
              .where("register", "==", this.loginForm.register)
              .limit(1)
              .get();
            if (!stsdata.empty) {
              this.isTeacher = false;
              this.showUserName = false;
              this.showCode = true;
            } 
            else {
              alert(
                "Таны регистрийн дугаар системд бүртгэлгүй байна . Та сургалтын албандаа хандана уу."
              );
            }
          }
        } 
        else alert("Та регистрийн дугаарaa оруулна уу");
      } 
      else if (this.showCode == true) {
        if (
          this.loginForm != null &&
          this.loginForm.register != null &&
          this.loginForm.code != "" &&
          this.loginForm.code != null &&
          this.loginForm.code != ""
        ) {
          this.checkCode(this.loginForm.code);
        } else alert("Та кодоо оруулна уу");
      }
      else if (this.showAddInfo == true) {
        if (
          this.user != null &&
          this.user.phone != null &&
          this.user.phone != "" &&
          this.user.email != null &&
          this.user.email != ""
        ) {
          if (this.isTeacher == true) {
            var datas = await fb.db
              .collection("teachers")
              .where("code", "==", this.loginForm.code)
              .where("register", "==", this.loginForm.register)
              .limit(1)
              .get();
            if (!datas.empty) {
              var userObj = datas.docs[0];
              userObj.ref.update({
                email: this.user.email,
                phone: this.user.phone,
                createdAt: new Date()
              });
              fb.usersCollection
                .doc(this.currentUser.uid)
                .update({ profileInfoAdded: true, createdAt: new Date() });
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            } 
            else {
              alert(
                "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
              );
            }
          }
          else {
            var stsdata = await fb.db
              .collection("students")
              .where("code", "==", this.loginForm.code)
              .where("register", "==", this.loginForm.register)
              .limit(1)
              .get();
            if (!stsdata.empty) {
              console.log(stsdata.docs[0].data());
              var userObj = stsdata.docs[0];
              userObj.ref.update({
                email: this.user.email,
                phone: this.user.phone,
                createdAt: new Date()
              });
              fb.usersCollection
                .doc(this.currentUser.uid)
                .update({ profileInfoAdded: true, createdAt: new Date() });
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            }
            else
              alert(
                "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
              );
          }
        }
        else alert("Та утасны дугаар болон имэйл хаягаа оруулна уу");
      }
    },
    async checkCode(code) {
      if (code != null && code != null && code != "") {
        if (this.isTeacher == true) {
          var datas = await fb.db
            .collection("teachers")
            .where("code", "==", code)
            .where("register", "==", this.loginForm.register)
            .limit(1)
            .get();
          if (!datas.empty) {
            var userObj = datas.docs[0];
            fb.usersCollection.doc(this.currentUser.uid).update({
              role: "teacher",
              code: code,
              register: this.loginForm.register,
              customer: userObj.ref,
              verified: true,
              createdAt: new Date()
            });
            if (
              this.provider != null &&
              this.provider != "" &&
              this.provider == "google"
            )
              userObj.ref.update({
                googleUser: fb.usersCollection.doc(this.currentUser.uid)
              });
            else if (
              this.provider != null &&
              this.provider != "" &&
              this.provider == "facebook"
            )
              userObj.ref.update({
                fbUser: fb.usersCollection.doc(this.currentUser.uid)
              });
            else if (
              this.provider != null &&
              this.provider != "" &&
              this.provider == "apple"
            )
              userObj.ref.update({
                appleUser: fb.usersCollection.doc(this.currentUser.uid)
              });
            else
              userObj.ref.update({
                unidentified: fb.usersCollection.doc(this.currentUser.uid)
              });
            if (this.profileInfoAdded == false) {
              this.showUserName = false;
              this.showCode = false;
              this.showAddInfo = true;
            } 
            else {
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            }
          } 
          else {
            alert(
              "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
            );
          }
        } 
        else {
          var stsdata = await fb.db
            .collection("students")
            .where("code", "==", code)
            .where("register", "==", this.loginForm.register)
            .limit(1)
            .get();
          if (!stsdata.empty) {

            var userObj = stsdata.docs[0];
            fb.usersCollection.doc(this.currentUser.uid).update({
              role: "student",
              code: code,
              register: this.loginForm.register,
              customer: userObj.ref,
              verified: true,
              createdAt: new Date()
            });
            
            if (
              this.provider != null &&
              this.provider != "" &&
              this.provider == "google"
            )
              userObj.ref.update({
                googleUser: fb.usersCollection.doc(this.currentUser.uid)
              });
            else if (
              this.provider != null &&
              this.provider != "" &&
              this.provider == "facebook"
            )
              userObj.ref.update({
                fbUser: fb.usersCollection.doc(this.currentUser.uid)
              });
            else if (
              this.provider != null &&
              this.provider != "" &&
              this.provider == "apple"
            )
              userObj.ref.update({
                appleUser: fb.usersCollection.doc(this.currentUser.uid)
              });
            else
              userObj.ref.update({
                unidentified: fb.usersCollection.doc(this.currentUser.uid)
              });
              
            if (this.profileInfoAdded == false) {
              this.showUserName = false;
              this.showCode = false;
              this.showAddInfo = true;
            } else {
              this.$store.dispatch("fetchUserProfile");
              this.$store.dispatch("setEnabledTrue");
              this.$router.push("/hello");
            }
          } 
          else {
            alert(
              "Таны регистрийн дугаар болон код зөрж байна . Та сургалтын албандаа хандана уу."
            );
          }
        }
      }
      else alert("Та регистрийн дугаарaa оруулна уу");
    }
  }
};
</script>

